import styled from "ibis-design-system/lib/HelperFunctions/ThirdParty/styled-components";

export const MT20 = styled.div`
  margin-top: 20px;
`